import { render, staticRenderFns } from "./cbuyhis.vue?vue&type=template&id=63a1f628&"
import script from "./cbuyhis.vue?vue&type=script&lang=js&"
export * from "./cbuyhis.vue?vue&type=script&lang=js&"
import style0 from "./cbuyhis.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports